import { Component, OnInit } from '@angular/core';
import { TenantFeatures } from 'app/state/feature.repository';

@Component({
    selector: 'app-timelogs',
    templateUrl: './timelogs.component.html',
    styleUrls: ['./timelogs.component.scss'],
    standalone: false
})
export class TimelogsComponent implements OnInit {
  tenantFeatures = TenantFeatures;
  constructor() {}
  ngOnInit(): void {}
}
